@layer component {
  .btn {
    @apply inline-flex justify-center items-center rounded relative overflow-hidden;
    min-width: 34px;
    min-height: 34px;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 0.15s;
  }
  .tooltip-button__popover {
    @apply pointer-events-none;
  }
  .btn.small > .icn {
    @apply mr-1;
  }
  .btn > .icn {
    @apply mr-2 leading-none;
  }
}

.btn {
  @apply px-4 py-1 text-sm text-fg1;
  line-height: 1.1;
  transition-property: box-shadow, color;
}

button:focus,
.btn:focus {
  outline: none;
}

.btn:hover {
  @apply text-fg3;
}

.btn.primary,
.btn.success,
.btn.warning,
.btn.danger {
  @apply text-white;
}

.btn.primary:hover,
.btn.success:hover,
.btn.warning:hover,
.btn.danger:hover {
  @apply text-white;
}

.btn:active {
  @apply text-fg3;
}

.btn:focus {
  background-color: hsla(0, 0%, 100%, 0.05);
}
.light .btn:not(.primary):not(.danger):focus {
  background-color: hsla(0, 0%, 100%, 0.5);
}

.btn:not(.no-children),
.btn.rounded-none {
  transition-property: box-shadow, color, background-color;
}
.btn:not(.no-children):hover,
.btn.rounded-none:hover {
  background-color: hsla(0, 0%, 100%, 0.066);
}
.light .btn:not(.primary):not(.danger):not(.no-children):hover,
.light .btn.rounded-none:hover {
  background-color: hsla(0deg, 0%, 100%, 1);
}

.btn.small,
.btn.tiny {
  @apply text-xs;
}
.btn.small {
  @apply px-2;
  min-width: 24px;
  min-height: 24px;
}
.btn.tiny {
  padding: 2px;
  min-width: 20px;
  min-height: 20px;
}

.btn.stacked {
  @apply flex-col p-2;
}
.light .btn.stacked {
  box-shadow: var(--shadow-secondary);
}

.btn.no-children {
  @apply px-1;
}

.btn.no-children:not(.rounded-none) {
  @apply bg-no-repeat bg-center;
  transition-property: box-shadow, color, background-size;
  background-size: 0% 0%;
  background-image: linear-gradient(
    hsla(0, 0%, 100%, 0.066),
    hsla(0, 0%, 100%, 0.066)
  );
}
.light .btn.no-children:not(.rounded-none) {
  background-image: linear-gradient(
    hsla(0, 0%, 100%, 0.66),
    hsla(0, 0%, 100%, 0.66)
  );
}
.btn.no-children:not(.rounded-none):hover {
  background-size: 100% 100%;
}

.btn.micro {
  padding: 0;
  min-width: auto;
  min-height: auto;
}
.btn.no-children > .icn {
  @apply m-0;
}
.btn.stacked > .icn {
  @apply mr-0 mb-2;
}
.btn.stacked.small > .icn {
  @apply mb-1;
}
.btn.is-loading {
  opacity: 1;
}

.btn.primary:not(.is-text),
.btn.success:not(.is-text),
.btn.warning:not(.is-text),
.btn.danger:not(.is-text) {
  background-image: linear-gradient(
    to bottom,
    hsla(0, 0%, 100%, 0.1),
    hsla(0, 0%, 100%, 0)
  );
}

.btn.primary:active,
.btn.success:active,
.btn.warning:active,
.btn.danger:active {
  background-image: none;
}

.btn.primary:hover,
.btn.success:hover,
.btn.warning:hover,
.btn.danger:hover {
  box-shadow:
    0 2px 4px -1px hsla(0, 0%, 0%, 0.2),
    0 4px 5px 0 hsla(0, 0%, 0%, 0.14),
    0 1px 10px 0 hsla(0, 0%, 0%, 0.12);
}

.btn.primary {
  @apply bg-pr2;
}
.btn.primary:hover {
  @apply bg-pr3;
}
.btn.primary:focus {
  box-shadow:
    0 0 0 3px hsla(202, 75%, 35%, 0.35),
    0 2px 4px -1px hsla(0, 0%, 0%, 0.2),
    0 4px 5px 0 hsla(0, 0%, 0%, 0.14),
    0 1px 10px 0 hsla(0, 0%, 0%, 0.12);
}
.light .btn.primary:focus {
  box-shadow:
    0 0 0 3px hsla(202, 75%, 35%, 0.15),
    0 2px 4px -1px hsla(0, 0%, 0%, 0.1),
    0 4px 5px 0 hsla(0, 0%, 0%, 0.04),
    0 1px 10px 0 hsla(0, 0%, 0%, 0.02);
}
.light .btn.primary:active {
  @apply text-bg3;
}
.btn.primary.is-text {
  @apply text-pr2 shadow-none;
  background-color: unset;
}
.btn.primary.is-text:hover {
  @apply text-pr3;
  background-color: unset;
}

.btn.success {
  @apply bg-sc2;
}
.btn.success:hover {
  @apply bg-sc3;
}
.btn.success:focus {
  box-shadow:
    0 0 0 3px hsla(141, 82%, 41%, 0.35),
    0 2px 4px -1px hsla(0, 0%, 0%, 0.2),
    0 4px 5px 0 hsla(0, 0%, 0%, 0.14),
    0 1px 10px 0 hsla(0, 0%, 0%, 0.12);
}
.btn.success.is-text {
  @apply text-sc2 shadow-none;
  background-color: unset;
}
.btn.success.is-text:hover {
  @apply text-sc3;
  background-color: unset;
}

.btn.warning {
  @apply bg-wr2;
}
.btn.warning:hover {
  @apply bg-wr3;
}
.btn.warning:focus {
  box-shadow:
    0 0 0 3px hsla(30, 70%, 51%, 0.35),
    0 2px 4px -1px hsla(0, 0%, 0%, 0.2),
    0 4px 5px 0 hsla(0, 0%, 0%, 0.14),
    0 1px 10px 0 hsla(0, 0%, 0%, 0.12);
}
.btn.warning.is-text {
  @apply text-wr2 shadow-none;
  background-color: unset;
}
.btn.warning.is-text:hover {
  @apply text-wr3;
  background-color: unset;
}

.btn.danger {
  @apply bg-dr2;
}
.btn.danger:hover {
  @apply bg-dr3;
}
.btn.danger:focus {
  box-shadow:
    0 0 0 3px hsla(0, 100%, 50%, 0.35),
    0 2px 4px -1px hsla(0, 0%, 0%, 0.2),
    0 4px 5px 0 hsla(0, 0%, 0%, 0.14),
    0 1px 10px 0 hsla(0, 0%, 0%, 0.12);
}
.btn.danger.is-text {
  @apply text-dr2 shadow-none;
  background-color: unset;
}
.btn.danger.is-text:hover {
  @apply text-dr3;
  background-color: unset;
}

.btn.secondary {
  background-color: hsla(0, 0%, 100%, 0.025);
  box-shadow: var(--shadow-secondary);
}
.light .btn.secondary {
  @apply bg-bg2;
}

.btn.is-disabled {
  @apply opacity-50 pointer-events-none;
}
